<template>
	<v-progress-circular
		:value="counts.progress"
		class="progress-circle"
		color="orange"
		rotate="-90"
		width="4"
		size="56"
	>
		<div class="progress-circle--info orange--text body-2">
			<span>{{ counts.completed }}</span>
			<v-divider class="divider" />
			<span>{{ counts.total }}</span>
		</div>
	</v-progress-circular>
</template>

<style lang="scss" scoped>
.progress-circle .progress-circle--info {
	display: inline-block;

	.divider {
		border-color: var(--v-orange-base);
	}
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters({
			devices: "devices/devices",
			pairedDevices: "devices/pairedDevices",
		}),

		counts() {
			const total = this.devices.length;
			const completed = this.pairedDevices.length;
			const progress = 100 * (completed / total);

			return { total, completed, progress };
		},
	},
};
</script>
